import React from 'react';

const CTA = () => {
  return (
    <section className="section-padding text-center bg-light">
      <div className="container">
        <h2 className="lang-en">Each company - its own subdomain.</h2>
        <h2 className="lang-ar" style={{ display: 'none' }}>كل شركة - نطاق فرعي خاص بها.</h2>
        <p className="lang-en">Start free today and get your cloud workspace in minutes - no servers, no hassle.</p>
        <p className="lang-ar" style={{ display: 'none' }}>ابدأ مجاناً اليوم واحصل على مساحة عمل سحابية في دقائق - بدون خوادم أو تعقيدات.</p>
        <a href="/register" className="btn btn-common mt-3 lang-en">Start Free Trial</a>
        <a href="/register" className="btn btn-common mt-3 lang-ar" style={{ display: 'none' }}>ابدأ تجربتك المجانية</a>
      </div>
    </section>
  );
};

export default CTA;
